import { installSessionStorageTextSanitizer } from './utils/browserStorageSanitizer.js';

installSessionStorageTextSanitizer();

import './vaadin-lumo-theme.js';
import '@vaadin/icon';
import '@vaadin/icons/vaadin-iconset.js';
import '@vaadin/button';
import '@vaadin/grid/vaadin-grid-sort-column.js';
import '@vaadin/grid/vaadin-grid-column-group.js';
import '@vaadin/grid/vaadin-grid-filter-column.js';
import '@vaadin/grid/vaadin-grid-filter.js';
import '@vaadin/grid/vaadin-grid-selection-column.js';
import '@vaadin/grid/vaadin-grid-sorter.js';
import '@vaadin/grid/vaadin-grid-tree-column.js';
import '@vaadin/grid/vaadin-grid-tree-toggle.js';
import '@vaadin/grid';
import '@vaadin/text-field';
import '@vaadin/email-field';
import '@vaadin/number-field';
import '@vaadin/password-field';
import '@vaadin/text-area';
import '@vaadin/integer-field';
import '@vaadin/custom-field';
import '@vaadin/combo-box';
import '@vaadin/multi-select-combo-box';
import '@vaadin/context-menu';
import '@vaadin/time-picker';
import '@vaadin/date-picker';
import '@vaadin/date-time-picker';
import '@vaadin/radio-group';
import '@vaadin/checkbox';
import '@vaadin/checkbox-group';
import '@vaadin/list-box';
import '@vaadin/item';
import '@vaadin/scroller';
import '@vaadin/select';
import '@vaadin/form-layout';
//import '@vaadin/ordered-layout';
import '@vaadin/app-layout';
import '@vaadin/split-layout';
import '@vaadin/vertical-layout';
import '@vaadin/dialog';
import '@vaadin/details';
import '@vaadin/upload';
import '@vaadin/virtual-list';
import '@vaadin/login';
import '@vaadin/login/vaadin-login-form.js';
import '@vaadin/tabs';
import '@vaadin/tabsheet';
import '@vaadin/menu-bar';
import '@vaadin/progress-bar';
import '@vaadin/accordion';
import '@vaadin/notification';
//import '@polymer/vaadin-icon';

import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faBolt, faCog, faFrown, faQuestion, faQuestionCircle, faInfo, faInfoCircle, faSave, faSign, faPlug, faSkullCrossbones, faExclamationCircle, faExclamationTriangle, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import './my-element.js';

import {Service} from './service/service.js';
import {BillingService} from './service/billing/billingService.js';
import {DataManagementService} from './service/datamanagement/dataManagementService.js';
import {UnitService} from './service/unit/unitService.js';
import {RoutingService} from './service/routing/routingService.js';
import {ElementUtil} from './utils/elementUtil.js';
import {MessageUtil} from './utils/messageUtil.js';
import {LoaderUtil} from './utils/loaderUtil.js';
import {TimeUtil} from './utils/timeUtil.js';
import {ImportUtil} from './utils/importUtil.js';
import './utils/pageRegistry.js';

import './component/userMenu.js';
import './component/header.js';
import './component/footer.js';
import './component/sidenav.js';
import './component/maincontent.js';

import './component/common/actionButton.js';
import './component/common/dialogWindow.js';
import './component/common/formPanel.js';
import './component/common/gridLayout.js';
import './component/common/flexLayout.js';
import './component/common/pagingToolbar.js';
import './component/common/toolbar.js';
import './component/common/detailTable.js';
import './component/common/nextPrevToolbar.js';
import './component/common/tabPanel.js';
import './component/common/userSelect.js';
import './component/common/richtext.js';
import './component/common/floatingWindow.js';
import './component/common/sectionTitle.js';
import './component/common/sectionPanel.js';
import './component/common/mapPanel.js';
import './component/common/locationLookup.js';
import './component/common/toggleSwitch.js';
import './component/common/tagField.js';
import './component/common/regexTestForm.js';
import './component/common/transformChainField.js';
import './component/common/actionMenuItem.js';
import './component/common/exportToolbar.js';
import './component/common/unitSelection.js';
import './component/common/chartPanel.js';

import './component/system/lookupgrid.js';
import './component/system/securitypolicyform.js';
import './component/system/trackingGrid.js';
import './component/system/nodeOverview.js';
import './component/system/nodeWidget.js';
import './component/system/appProperties.js';
import './component/system/appInitStatus.js';
import './component/system/dbLogsGrid.js';
import './component/system/jobsGrid.js';
import './component/system/jobAssignmentGrid.js';
import './component/system/nodeDetails.js';
import './component/system/threadsGrid.js';
import './component/system/managerGrid.js';
import './component/system/cachingControlGrid.js';
import './component/system/logsGrid.js';
import './component/system/backgroundTasksGrid.js';
import './component/system/pluginGrid.js';
import './component/system/feedbackGrid.js';
import './component/system/errorTicketGrid.js';
import './component/system/userMessageGrid.js';
import './component/system/emailHistoryGrid.js';
import './component/system/alertGrid.js';
import './component/system/brandingGrid.js';
import './component/system/helpGrid.js';
import './component/system/mediaGrid.js';
import './component/system/testCaseGrid.js';
import './component/system/fileStatsGrid.js';
import './component/system/fileManagementGrid.js';
import './component/system/systemStatsGrid.js';
import './component/system/backgroundOutputGrid.js';
import './component/system/featureSwitches.js';
import './component/system/applicationModuleGrid.js';
import './component/system/dataBlockGrid.js';
import './component/system/messageTemplateGrid.js';
import './component/system/systemUpdateGrid.js';
import './component/system/appScriptGrid.js';

import './component/system/apimanagement/serviceAccountGrid.js';
import './component/system/apimanagement/apiTracking.js';
import './component/system/apimanagement/apiRestrictionsGrid.js';
import './component/system/apimanagement/webhooksGrid.js';
import './component/system/apimanagement/apiDataBufferGrid.js';

import './component/accounts/accountManagementGrid.js';

import './component/routing/postalCityCodeGrid.js';
import './component/routing/cityXrefGrid.js';
import './component/routing/routingTool.js';
import './component/routing/routingPipelineTool.js';
import './component/routing/crowFlyTool.js';
import './component/routing/mapTool.js';
import './component/routing/geotunnelingTool.js';
import './component/routing/geocodingTool.js';
import './component/routing/routingOptions.js';
import './component/routing/routingOptionsForm.js';
import './component/routing/tollDiscountGrid.js';

import './component/datamanagement/taskGrid.js';
import './component/datamanagement/batchWorkGrid.js';
import './component/datamanagement/undoManagementGrid.js';
import './component/datamanagement/integrations.js';
import './component/datamanagement/dataRetentionPolicyGrid.js';
import './component/datamanagement/datalockGrid.js';
import './component/datamanagement/dataHandlerVisibilityGrid.js';
import './component/datamanagement/datafilterGrid.js';
import './component/datamanagement/gpsFilteringGrid.js';
import './component/datamanagement/calcPipeline.js';
import './component/datamanagement/customDataHandlerGrid.js';
import './component/datamanagement/dataTransformRuleSetGrid.js';
import './component/datamanagement/importGrid.js';
import './component/datamanagement/importOptionForm.js';
import './component/datamanagement/datalinksGrid.js';
import './component/datamanagement/gpsLocationsGrid.js';
import './component/datamanagement/fuelGrid.js';
import './component/datamanagement/distanceSummaryContainer.js';
import './component/datamanagement/distanceSummaryGrid.js';
import './component/datamanagement/tripsheetGrid.js';
import './component/datamanagement/tripContainer.js';
import './component/datamanagement/tripGrid.js';
import './component/datamanagement/tripStopGrid.js';
import './component/datamanagement/timeToolSyncGrid.js';
import './component/datamanagement/timeToolZoneGrid.js';
import './component/datamanagement/datawatchesGrid.js';
import './component/datamanagement/archiveGrid.js';
import './component/datamanagement/migrationGrid.js';
import './component/datamanagement/adminDistanceSummaryGrid.js';
import './component/datamanagement/adminFuelGrid.js';
import './component/datamanagement/adminGPSGrid.js';
import './component/datamanagement/adminTripContainer.js';
import './component/datamanagement/adminTripGrid.js';
import './component/datamanagement/adminTripStopGrid.js';
import './component/datamanagement/integrationLogsGrid.js';

import './component/fueltax/craRatesGrid.js';
import './component/fueltax/stateTaxTypeGrid.js';
import './component/fueltax/stateTaxRateGrid.js';
import './component/fueltax/iftaInterestGrid.js';
import './component/fueltax/iftaRatesGrid.js';
import './component/fueltax/fueltaxPrefForm.js';

import './component/unit/autoUnitGrid.js';
import './component/unit/autoGroupGrid.js';
import './component/unit/unitMatchSetGrid.js';
import './component/unit/driverGrid.js';
import './component/unit/trailerGrid.js';
import './component/unit/fuelTanksGrid.js';
import './component/unit/tractorGrid.js';
import './component/unit/unitGroupGrid.js';

import './component/unit/adminDriverGrid.js';
import './component/unit/adminTractorGrid.js';
import './component/unit/adminTrailerGrid.js';

import './component/reporting/reportVisibilityGrid.js';
import './component/reporting/reportsGrid.js';
import './component/reporting/generateReportForm.js';
import './component/reporting/scheduledReportsGrid.js';
import './component/reporting/optionMpgType.js';
import './component/reporting/optionHighlightFields.js';
import './component/reporting/optionYearMonthQuarter.js';
import './component/reporting/optionPeriodOrDateRange.js';
import './component/reporting/closeReportsGrid.js';
import './component/reporting/distancePrefReport.js';
import './component/reporting/customTemplateReport.js';

import './component/company/companyForm.js';
import './component/company/companyAdminGrid.js';
import './component/company/companyTypeConfigGrid.js';
import './component/accounts/roleGrid.js';
import './component/accounts/userGrid.js';

import './component/user/notificationGrid.js';
import './component/user/feedbackForm.js';
import './component/user/userProfileForm.js';
import './component/user/changePasswordForm.js';
import './component/user/notificationWatcher.js';
import './component/user/versionWatcher.js';
import './component/user/dashboard.js';
import './component/user/dashboardWidget.js';

import './component/billing/salesRepsGrid.js';
import './component/billing/referenceCompanyGrid.js';
import './component/billing/promotionsGrid.js';
import './component/billing/bundleGrid.js';
import './component/billing/tchAccountsGrid.js';
import './component/billing/factoringGrid.js';
import './component/billing/referralProgramGrid.js';
import './component/billing/referralGrid.js';
import './component/billing/productGrid.js';
import './component/billing/customerAppGrid.js';
import './component/billing/accountGrid.js';

import './component/billing/account/generalInfo.js';
import './component/billing/account/commentGrid.js';
import './component/billing/account/orderGrid.js';
import './component/billing/account/invoiceGrid.js';
import './component/billing/account/paymentGrid.js';
import './component/billing/account/adjustmentGrid.js';
import './component/billing/account/factorSetupGrid.js';
import './component/billing/account/contractGrid.js';
import './component/billing/account/billingPreferences.js';
import './component/billing/account/accountControl.js';

import './component/securefuel/sfAuthUnitGroupGrid.js';
import './component/securefuel/sfUnitsGrid.js';
import './component/securefuel/sfVehiclePosition.js';

/* global fetch, Element */

function getDefaultBranding() {
	return {
		logoURL: './image/logo-wex.png',
		backgroundURL: './image/prism.png',
		loginTitle: 'Driveline',
		loginDescription: '',
		footerCompany: 'WEX',
		headerBackgroundColor: '#383636',
		headerTextColor: 'white',
		companyTextColor: 'gold',
		primaryBackgroundColor: '#e41736',
		primaryTextColor: 'white',
		navBackgroundColor: '#e41736',
		navOffBackgroundColor: '#192434',
		navTextColor: 'white',
		menuColor: '#e41736'
	};
}

function initializeWindowDL() {
	window.DL = window.DL || {};
	window.DL.MessageUtil = window.DL.MessageUtil || new MessageUtil();
	window.DL.BillingService = BillingService;
	window.DL.DataManagementService = DataManagementService;
	window.DL.Service = Service;
	window.DL.ElementUtil = ElementUtil;
	window.DL.LoadingUtil = LoaderUtil;
	window.DL.showLogin = showLogin;
	window.DL.validLoginProceed = validLoginProceed;
	window.DL.Branding = window.DL.Branding || getDefaultBranding();

	window.DL.colorModeSwitch = function(darkMode) {
		if (darkMode) {
			window.DL.colorMode = {
				background: '#333333',
				textColor: '#d9e1ec',
				adminMenu: '#373f5c'
			};
		} else {
			window.DL.colorMode = {
				background: 'white',
				textColor: 'black',
				adminMenu: 'beige'
			};
		}
	};
	window.DL.colorModeSwitch();

	window.DL.switchMainCss = function(mode) {
		var darkMode = false;
		if (mode === 'dark') {
			darkMode = true;
		} else if (mode === 'system') {
			if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
				darkMode = true;
			}
		}

		if (darkMode) {
			document.getElementById('main-css').href = 'styles/main-dark.css';
			window.DL.colorModeSwitch(true);
		} else {
			document.getElementById('main-css').href = 'styles/main.css';
			window.DL.colorModeSwitch();
		}
	};
}

function startApplication() {
	library.add(
		faCheck,
		faBolt,
		faCog,
		faFrown,
		faQuestion,
		faQuestionCircle,
		faInfo,
		faInfoCircle,
		faSave,
		faSign,
		faPlug,
		faWindowClose,
		faSkullCrossbones,
		faExclamationCircle,
		faExclamationTriangle
	);
	dom.watch();

	initUI();
}

window.addEventListener('WebComponentsReady', () => {
	initializeWindowDL();

	Service.getBrandingService().getCurrentBranding()
		.then(function(branding) {
			window.DL.Branding = branding;
			startApplication();
		})
		.catch(function(error) {
			// Unauthenticated bootstrap: handleResponseError already opened login for 401.
			if (error && error.res && error.res.status === 401) {
				return;
			}
			startApplication();
		});
});

function showLogin(successCallback) {
	const paramRaw = new URLSearchParams(window.location.search);
	const params = Object.fromEntries(paramRaw.entries());
		
	if (window.DL.Branding.ssoEnabled && 
		window.DL.Branding.ssoLoginURL &&
		!params.internallogin) {
		window.location.href = window.DL.Branding.ssoLoginURL;
	} else {		
		var loginWin = ElementUtil.create({
		tag: 'dl-dialog',
		title: window.DL.Branding.loginTitle,
		icon: 'vaadin:lock',
		width: '500',
		height: '450',
		notClosable: true,
		scope: 'app',
		backdropExtraStyle: 'background: radial-gradient(circle, rgba(74, 102, 125, .7) 0%, rgba(33, 61, 84, .4) 100%), url(/image/prism.png);',
		listeners: {
			ready: function() {
				loginWin.show();

				var loginForm = document.createElement('vaadin-login-form');
				loginForm.setAttribute('theme', 'custom-background');

				var defaultI18n = loginForm.i18n;
				loginForm.i18n = Object.assign({}, defaultI18n, {
					form: Object.assign({}, defaultI18n.form, {
						title: 'Log in'
					}),
					additionalInformation: window.DL.Branding.loginDescription || ''
				});

				var loginWrapper = ElementUtil.create({
					tag: 'div',
					'class': 'center-login',
					children: [loginForm]
				});

				loginWin.addToContentElement(loginWrapper);

				loginForm.addEventListener('login', function (e) {
					var loadMask = window.DL.MessageUtil.fullPageLoadMask('<i class="fas fa-cog fa-spin fa-2x"></i> Authenticating...');

					let formData = new FormData();
					formData.append('username', e.detail.username);
					formData.append('password', e.detail.password);

					fetch(new Request('/login', { method: 'POST', body: formData})).then(function(response){
						loadMask.opened = false;
						if (response.ok && !response.url.endsWith('error')) {						
							Service.getCompanyService().clearWorkingCompany();
							
							loginWin.close();
							successCallback();
						} else {
							loginForm.error = true;
						}
					});
				});

				loginForm.addEventListener('forgot-password', function () {
					//window.DL.MessageUtil.showOkMessage('Not Implemented Yet');

					var forgotWin = ElementUtil.create({
						tag: 'dl-dialog',
						title: 'Forgot Password',
						icon: 'vaadin:lock',
						width: '400',
						height: '200',
						scope: 'app',
						listeners: {
							ready: function() {						
								forgotWin.show();

								var formPanel = ElementUtil.create({
									tag: 'dl-form-panel',								
									itemid: 'form',
									children: [
										{										
											tag: 'vaadin-form-layout',
											children: [	
												{
													tag: 'vaadin-text-field',
													name: 'userId',
													label: 'Enter your username',
													required: true,
													maxlength: 120
												}
											]
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:envelope', ' Send Request')
													],
													listeners: {
														click: function() {		

															if (formPanel.isValid()) {

																var formData = formPanel.getData();

																fetch('/request-reset-password/'+ formData.userId).then(function(response){
																	if (response.ok) {
																		window.DL.MessageUtil.showOkMessage('An email was sent to the address for the account.<br><br>Check your email and follow the instructions to complete your reset.', function(){
																			forgotWin.close();
																		});
																	} else {
																		window.DL.MessageUtil.showOkMessage('Unable to submit request. Try again; if this persist contact support.');
																	}
																});

															}																	
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',												
													listeners: {
														click: function() {
															forgotWin.close();
														}
													}
												}
											]
										}
									]
								});

								forgotWin.addToContentElement(formPanel);

							}
						}
					});

				});	
				
			}
		}
	});
	}
	
}

function initUI() {
	
	//check login	
	checklogin().then(function(validLogin){
		if (validLogin) {			
			validLoginProceed();			
		} else {
			showLogin(function(){
				validLoginProceed();
			});		
		}		
	});	
	
};

function validLoginProceed() {
	//refresh branding
	Service.getBrandingService().getCurrentBranding().then(function(branding){
		window.DL.Branding = branding;	
		
		//pull user and init header, menu, and navigation
		Service.getUserService().getCurrentUser().then(function(user) {
		window.DL.currentUser = user;
		
		var loadMainPage = function() {
			if (user.userProfile.uiColorMode) {
				window.DL.switchMainCss(user.userProfile.uiColorMode); 				
			}
			LoaderUtil.loadView(document.querySelector('#main'), './views/main.html');
		};
		
		//check for password reset requirement
		if (user.resetPasswordPromptFlag) {
			//prompt for reset 
			var promptResetWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Reset Password',
				icon: 'vaadin:lock',
				width: '600px',
				height: '300px',
				notClosable: true,
				scope: 'app',
				listeners: {
					ready: function() {						
						promptResetWin.show();
						
						var resetForm = ElementUtil.create({
							tag: 'dl-changepassword-form',
							listeners: {
								'saved': function() {
									user.resetPasswordPromptFlag = false;
									promptResetWin.close();
									loadMainPage();
								}
							}
						});
						
						promptResetWin.addToContentElement(resetForm);
					}
				}
			});
		} else if (user.changePasswordPromptFlag) {
			var promptChangeWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: user.passwordExpiredFlag ? 'Change Expired Password' : 'Change Expiring Password',
				icon: 'vaadin:lock',
				width: '600px',
				height: '300px',
				notClosable: true,
				scope: 'app',
				listeners: {
					ready: function() {						
						promptChangeWin.show();
						
						var resetForm = ElementUtil.create({
							tag: 'dl-changepassword-form',
							listeners: {
								'saved': function() {
									user.changePasswordPromptFlag = false;
									promptChangeWin.close();
									loadMainPage();
								}
							}
						});
						
						promptChangeWin.addToContentElement(resetForm);
					}
				}
			});
		} else {		
			//if not load main
			loadMainPage();
		}
	});
	});
}

async function checklogin() {
	
	//check session cookie (we need clear the creditials)
	
	// then set , { credentials: 'omit' }
	
	
	const res = await fetch("/checklogin", {
		cache: 'no-cache',
		headers: {
			'Authorization': ''
		}
	});
	var validLoginText = await res.text();
	if (validLoginText === 'valid'){
		return true;
	} else {
		return false;
	}
};

